var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"no-margins",attrs:{"fluid":""}},[_c('Sitetour',{attrs:{"open":_vm.openGuide}}),_c('Welcome')],1)}
var staticRenderFns = []

export { render, staticRenderFns }